<template>
  <el-affix :offset="0">
  <div class="navTop">
    <div class="logo" @click="$router.push({path:'/'})">
      <img alt="logo" src="./assets/img/logosjyTop.png" width="343">
      <span>非盈利性科研机构</span>
    </div>

    <el-menu
        :default-active="activeIndex"
        active-text-color="#647D46"
        class="el-menu-demo"
        mode="horizontal"
        router
        style="width: 772px"
        text-color="#5A676E"
        @select="handleSelect"
    >
      <el-menu-item index="1" route="/">网站首页</el-menu-item>
      <el-sub-menu index="2">
        <template #title>培训项目</template>
<!--        <el-menu-item><a style="color: #5A676E" @click="toClass">心理咨询师基础培训</a></el-menu-item>-->
<!--        <el-menu-item route="/peixuntaocan">超值赠送专业技能课程</el-menu-item>-->
        <el-menu-item route="/cooperation">心理服务志愿者实践</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="3">
        <template #title>科学合作</template>
        <el-menu-item index="3-1" @click="workTogetherA">合作平台</el-menu-item>
        <el-menu-item index="3-2" @click="workTogetherB">合作机制</el-menu-item>
        <el-menu-item index="3-3" route="/agreementBook">志愿者报名</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="4">
        <template #title>走进三君</template>
        <el-menu-item index="4-1" route="/aboutUs">走进三君</el-menu-item>
      </el-sub-menu>
      <el-menu-item index="/aboutUs"><a @click="dialogVisible = true">联系我们</a></el-menu-item>
      <el-menu-item index="6" route="/KeyanList/1">科研成果</el-menu-item>
      <el-menu-item index="7" route="/XinWenList/1">新闻报道</el-menu-item>
    </el-menu>
    <a style="color:#0081FF;font-weight: 800" @click="go_zhuanweihui">
      <img src="./assets/img/zwh.gif">
    </a>
    <el-dialog
        v-model="dialogVisible"
        :before-close="handleClose"
        title="联系我们"
        width="30%"
    >
      <img alt="" src="./assets/img/1628822419438.png">
      <div>请使用微信扫描二维码联系我们</div>
      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
      </template>
    </el-dialog>


    <el-button v-if="$store.state.LoginStatus === 0" @click="toLogin">登录/注册</el-button>
    <span style="display: flex;align-items: center"  v-if="$store.state.LoginStatus === 1">
       <span
             style="display: flex;flex-direction: row-reverse;cursor: pointer;font-size: 12px; width: 200px;align-items: center"
             @click="$router.push({path:'/userIndex'})">
      <div style=" padding: 10px;">
        <span>{{ $store.state.name }}</span><br>
      <span>个人中心</span>
      </div>
      <img alt="" src="./assets/img/logo(2).png" style="width:20%">
    </span>
      <el-button @click="outLogin">退出登录</el-button>
      <el-dropdown v-if="isUser">
      <el-button @click="toGroup">
        进入后台
      </el-button>

      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item @click="$router.push({path:'/studentGroup'})">未开通权限信息管理</el-dropdown-item>
          <el-dropdown-item @click="$router.push({path:'/userGroup'})">学员信息管理</el-dropdown-item>
          <el-dropdown-item @click="$router.push({path:'/volunteerGroup'})">志愿者信息管理</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    </span>

  </div>
  </el-affix>
  <router-view></router-view>
</template>

<script>
import {onMounted, ref} from 'vue'
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {getUserInfo, outLoginApi} from "@/api/user";
import {ElMessage} from "element-plus";

export default {
  name: 'App',
  components: {},
  methods: {

    go_zhuanweihui(){
      location.href="http://www.isjpsy.com/public-zwh#/jianzhang"
    }
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const dialogVisible = ref(false)
    const isUser = ref(false)
    const activeIndex = ref('0')
   onMounted(()=>{
      console.log(store.state.LoginStatus);
     getUserInfo().then(res=>{
        console.log(res);
        if(res.data.state === 1){
          res.data.list.role_id == 2?isUser.value = true:isUser.value=false
          store.commit('setLoginStatus',1)
          store.commit('setRoleId',res.data.list.role_id)
          store.commit('setaccount',res.data.list.account)
          store.commit('setTime',res.data.list.create_time)
          store.commit('setbirthday',res.data.list.birthday)
          store.commit('setcost_flag',res.data.list.cost_flag)
          store.commit('setgangwei',res.data.list.gangwei)
          store.commit('setidnumber',res.data.list.idnumber)
          store.commit('setminzu',res.data.list.minzu)
          store.commit('setname',res.data.list.name)
          store.commit('setxueli',res.data.list.xueli)
          store.commit('setxuexiaozhuanye',res.data.list.xuexiaozhuanye)
          store.commit('setzhengzhi',res.data.list.zhengzhi)
          store.commit('setzhicheng',res.data.list.zhicheng)
          store.commit('setzyz_flag',res.data.list.zyz_flag)
          store.commit('setsex',res.data.list.sex)
          store.commit('setLoginStatus',1)
          console.log(store.state.LoginStatus)
        }else {
          store.commit('setLoginStatus',0)
        }
      })
    })
    const toLogin = ()=>{
      router.push({path:'/loginPage'})
    }
    const workTogetherA = () =>{
      router.push({path:'/workTogether/1'})
      setTimeout(()=>{
        window.location.reload()
      },500)
    }

    const workTogetherB = () =>{
      router.push({path:'/workTogether/2'})
      setTimeout(()=>{
        window.location.reload()
      },500)
    }

    const outLogin = ()=>{
      console.log(store.state.LoginStatus);
      outLoginApi().then(res=>{
        console.log(res);
          store.commit('setLoginStatus',0)
          console.log(store.state.LoginStatus)
          ElMessage.success('退出成功')
          setTimeout(()=>{
            router.push({path:'/'})
          },1000)
      }).catch(()=>{
        ElMessage.error('退出失败')
      })
    }

    const handleSelect = (key, keyPath) => {
      console.log(key, keyPath)
    }
    const toClass = () => {
      if(store.state.LoginStatus ==1){
       router.push({path:`/classAdmin?titleId=1`})
      }else {
        //router.push({path:`/classAdmin/1`})
        router.push({path: '/loginPage'})
      }
    }
    const go = () => {
      setTimeout(() => {
        document.getElementById("showA").scrollIntoView();
      }, 100)

    }
    return {
      activeIndex,
      handleSelect,
      dialogVisible,
      workTogetherA,
      workTogetherB,
      go,
      outLogin,
      isUser,
      toLogin,
      toClass
    }
  },
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: 0;
  padding: 0;
}

.el-menu--horizontal > .el-sub-menu .el-sub-menu__title {
  border: none !important;
}

.el-menu--horizontal {
  border-bottom: none;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.fl {
  float: left;
}

a {
  text-decoration: none;
}

.fr {
  float: right;
}

.clear {
  clear: both;
}
.el-dialog{
  width: max-content !important;
}
.logo {
  position: relative;
  cursor: pointer;

  span {
    position: absolute;
    left: 135px;
    font-size: 14px;
    top: 30px;
    font-weight: 800;
    color: #d90000;
  }
}
.el-tabs--left .el-tabs__item.is-left{
  text-align: center !important;
}
.el-affix{
  width: 100% !important;
}
.navTop {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  ul {
    display: flex;
  }

  button {
    background: #647D46 !important;
    color: #F2E7E7;
  }

  .el-dialog__headerbtn {
    background: #ffffff !important;
  }
}
</style>
